import { InsertRowLeftOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/community',
    name: 'community',
    redirect: '/community/list',
    meta: {
      title: '客户管理',
      sort: 1,
      icon: InsertRowLeftOutlined,
      isFullScreen: false,
      prem: true,
    },
    children: [
      {
        path: '/community/list',
        name: 'communityList',
        component: () => import('@/views/community/list/index.vue'),
        meta: { title: '客户列表', sort: 1, isFullScreen: false, keepAlive: true, prem: true },
      },
      {
        path: '/community/staff',
        name: 'communityStaff',
        component: () => import('@/views/system/staff/index.vue'),
        meta: { title: '工作人员', sort: 2, isFullScreen: false, keepAlive: true, prem: true },
      },
      {
        path: '/community/detail',
        name: 'communityDetail',
        component: () => import('@/views/community/detail/index.vue'),
        meta: {
          title: '楼栋管理',
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
      {
        path: '/community/fence',
        name: 'communityFence',
        component: () => import('@/views/community/fence/index.vue'),
        meta: {
          title: '维护围栏',
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
    ],
  },
]
